import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import './StickyMouseTooltip.scss';

function getWindowDimensions() {
  const {innerWidth: width, innerHeight: height} = window;
  return {
    width,
    height,
  };
}

function StickyMouseTooltip({children, visible, mousePosition}) {
  const screenHeight = useRef(0);
  const tooltipRef = useRef(null);
  const [offset, setOffset] = useState({x: 20, y: 30});

  useEffect(() => {
    function handleResize() {
      if (visible) {
        screenHeight.current = getWindowDimensions().height;
      }
    }

    const updateOffset = (y) => {
      const tooltipHeight = tooltipRef.current?.getBoundingClientRect().height;
      if (screenHeight.current - y < tooltipHeight + 40) {
        setOffset({x: 20, y: (tooltipHeight + 10) * -1});
      } else if (screenHeight.current - y >= tooltipHeight + 40) {
        setOffset({x: 20, y: 30});
      }
    };

    if (visible) {
      screenHeight.current = getWindowDimensions().height;
      updateOffset(mousePosition.y);
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [visible, mousePosition.y]);

  return (
    <div
      className="sticky-mouse-component"
      style={{
        display: visible ? 'block' : 'none',
        position: 'fixed',
        top: mousePosition.y + offset.y,
        left: mousePosition.x + offset.x,
        zIndex: '3',
      }}
    >
      <div ref={tooltipRef} className="sticky-mouse-tooltip">
        {children}
      </div>
    </div>
  );
}

StickyMouseTooltip.propTypes = {
  children: PropTypes.string,
  visible: PropTypes.bool,
  mousePosition: PropTypes.object,
};

StickyMouseTooltip.defaultProps = {
  children: null,
  visible: true,
  mousePosition: {x: null, y: null},
};

export default StickyMouseTooltip;
